import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Parser from 'rss-parser';
import Typography from '@material-ui/core/Typography';
import renderHTML from 'react-render-html';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import { isAuthenticated } from '../../auth/Auth';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  dateStyle: {
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: 12,
    marginBottom: 5
  },
  titlePost: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14
  },
  textContain: {
    padding: '5px 15px 15px 15px'
  },
  listPosts: {
    padding: 15
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  itemPost: {
    // backgroundColor: '#ffffff',
    marginBottom: 15,
    padding: 0
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('rssItems', 'setRssItems', []),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const parser = new Parser();
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/1c2977b2-f950-43f3-8eda-f669f30f3200.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssItems(feed.items);
        }
      );
    }
  })
);

const Main = enhance(({ classes, account, name, handleRedirect, rssItems }) => {
  const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
  const isReleased =
    account && account.accountStatus && account.accountStatus.status === true;

  // check if is account shop
  if (!(isShop && isReleased)) {
    handleRedirect('/shops');
  }
  return (
    <div className={classes.root}>
      <Header name={name} />
      <Typography variant="h5" className={classes.titlePage}>
        ごちめしの使い方
      </Typography>
      {rssItems && (
        <List
          component="nav"
          className={classes.listPosts}
          aria-label="contacts"
        >
          {rssItems.map((item, index) => {
            return (
              <>
                <ListItem
                  className={classes.itemPost}
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                >
                  <div>
                    <h4 className={classes.titleRss}>{item.title}</h4>
                    <div>{renderHTML(item.content)}</div>
                  </div>
                </ListItem>
              </>
            );
          })}
        </List>
      )}
      <MenuBox account={account} />
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
